import { z } from 'zod';

import { LocationId } from './Location';

export const QuestionnaireId = z.string().brand('QuestionnaireId');
export const Questionnaire = z.object({
  id: QuestionnaireId,
  locationId: LocationId,
  name: z.string(),
  description: z.string(),
  numberOfRespondents: z.number(),
  createdAt: z.string().datetime({ offset: true }),
  updatedAt: z.string().datetime({ offset: true }),
  expiredAt: z.string().datetime({ offset: true }),
});
export type QuestionnaireType = z.infer<typeof Questionnaire>;
